/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Resync_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to resync" |
*
* @param {Profile_Resync_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_resync_failed = /** @type {((inputs?: Profile_Resync_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Resync_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la resynchronisation")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al resincronizar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao ressincronizar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risincronizzazione fallita")
	return /** @type {LocalizedString} */ ("Failed to resync")
});